










import Vue from "vue";
import { AudioData } from "@tt-app/types";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";
import { audioContext } from "@tt-app/utils/audio/audioContext";

import IconSpeaker from "@joyz/app-core/assets/icons/white/Speaker.svg";

interface Data {
  icons: {
    [key: string]: string;
  };
  playedCount: number;
}

interface Computed {
  audioAvailable: boolean;
  disabled: boolean;
}

interface Props {
  audioData: AudioData;
  audioDecoderPlayer: AudioDecoderPlayer;
  playbackLimit: number | null;
  url: string;
}

export default Vue.extend<Data, {}, Computed, Props>({
  name: "ListeningAudio",

  props: {
    audioData: {
      type: Object,
      default: (): AudioData => ({})
    },
    audioDecoderPlayer: {
      type: AudioDecoderPlayer,
      default: undefined
    },
    playbackLimit: {
      type: Number,
      default: null
    },
    url: {
      type: String,
      required: true
    }
  },

  beforeDestroy() {
    this.audioDecoderPlayer?.stop();
  },

  data() {
    return {
      icons: {
        speaker: IconSpeaker
      },
      playedCount: 0
    };
  },

  methods: {
    async playAudio() {
      try {
        if (this.audioDecoderPlayer?.status === "playing") {
          this.audioDecoderPlayer.stop();
        }

        await audioContext.resume();
        await this.audioDecoderPlayer.play(this.url);
        this.playedCount += 1;
      } catch (error) {
        console.log("audioDecoderPlayer error", error);
      }
    }
  },

  computed: {
    audioAvailable() {
      const audioData = this.audioData[this.url];

      return Boolean(audioData);
    },

    disabled() {
      if (!this.playbackLimit) return false;

      return this.playedCount >= this.playbackLimit;
    }
  }
});
